export const hasRoutePermission = (roleEndpoints: string[], path: string) => {
  const endpointRegex = roleEndpoints.map((endpoint) => {
    const regexPattern = endpoint.replace(/:\w+/g, '[^/]+');
    return new RegExp(`^${regexPattern}$`);
  });

  return endpointRegex.some((regex) => regex.test(path));
};
